export default function ApiException(message) {
  this.message = message;
}
